__turbopack_context__.v({
  "animated": "Companies-module__JyvBXW__animated",
  "comapniesContainer": "Companies-module__JyvBXW__comapniesContainer",
  "companies": "Companies-module__JyvBXW__companies",
  "company": "Companies-module__JyvBXW__company",
  "companyImg": "Companies-module__JyvBXW__companyImg",
  "companyInfo": "Companies-module__JyvBXW__companyInfo",
  "reveal-up": "Companies-module__JyvBXW__reveal-up",
  "title": "Companies-module__JyvBXW__title",
});
